




















import docs from '@assets/staticPages'
import wrappers from '@/mixins/wrappers'
import { TrialTime, StaticPages } from '@/types/user'
type Doc = {
  header?: string;
  content: string;
}
type Docs = Doc[]
type DocHeaders = {
  [key in StaticPages]?: string
}
export default wrappers.extend({
  name: 'OnboardingDocs',
  props: {
    from: {
      type: String,
      default: 'tos'
    }
  },
  data () {
    const docsOrder = (['tos', 'privacy'] as StaticPages[]).filter(key => docs[key])
    const startIndex = docsOrder.indexOf(this.from as StaticPages)
    return {
      docIndex: ~startIndex ? startIndex : 0 as number,
      docsOrder: docsOrder as Array<StaticPages>
    }
  },
  computed: {
    wrapped (): Record<string, any> {
      return {
        actionAgree: this.offlineWrapper(this.actionAgree)
      }
    },
    trialTime (): TrialTime {
      return this.$store.getters['user/trialTime']
    },
    allDocs (): Docs {
      const docHeaders: DocHeaders = {
        tos: 'Please read and agree to the following terms and conditions',
        privacy: 'Please read and agree to the following privacy policy'
      }
      return (this.docsOrder as Array<StaticPages>).map(
        key => ({
          header: docHeaders[key],
          content: docs[key] as string
        })
      )
    },
    doc (): Doc {
      return this.allDocs[this.docIndex]
    },
    isLast (): boolean {
      return this.docIndex === this.allDocs.length - 1
    }
  },
  methods: {
    async actionAgree () {
      await this.$store.dispatch('user/AcceptAgreement', this.docsOrder[this.docIndex])
      if (this.isLast) {
        await this.$store.dispatch('user/Activate')
        if (this.trialTime.is().trialStarted) {
          await this.navigate({ name: 'Track' })
        }
        else {
          await this.navigate({ name: 'Goal:Start' })
        }
      }
      else {
        this.docIndex++
        if (this.$refs.content) {
          (this.$refs.content as any).scrollTop = 0
        }
      }
    },
    async actionDisagree () {
      await this.navigate({ name: 'Onboarding:Slides' })
    }
  }
})
